import React, { Component } from "react";
import CenterLayout from "../../layout/center/CenterLayout";

export default class CenterLayoutDemo extends Component {
  render() {
    return (
      <CenterLayout vgap={20} hgap={20}>
        <CenterLayout className="bg1" width={300} height={200}>
          居中
        </CenterLayout>
      </CenterLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/demo.centerLayout.js